"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
var _couponExpand = require("@/api/activity/couponExpand");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ExpandAdd',
  emits: ['saved'],
  props: {
    actId: {
      type: String,
      default: null
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newId, oldId) {
        console.log('newId', newId, oldId);
        // 避免初始化时的不必要调用
        if (newId && newId != '' && newId != 'null') {
          this.fetchActDetail(newId);
        }
        ;
        console.log('actId', newId);
      }
    }
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      // 控制 v-loading 显示隐藏

      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      time: [],
      form: {
        taskName: "",
        taskTitle: '',
        taskLabel: "",
        taskType: '',
        // taskDetail: '',
        taskRequirement: '',
        userScope: 3,
        mainImage: '',
        detailImage: '',
        taskImage: '',
        memberLevel: [],
        validType: 1,
        //1固定期限 2长期
        shareImage: '',
        shareTitle: '',
        keywordCondition: '',
        keywordList: '',
        minContentLength: '',
        status: 1,
        taskRule: '',
        taskSort: 0
      },
      baseReward: {
        rewardCategory: 1,
        ladderCount: '',
        rewardType: '',
        // 1: 积分, 2: 优惠券 3: 实物
        rewardValue: '',
        couponList: [{
          couponId: '',
          quantity: 1
        }]
      },
      // 优质额外奖励，支持多项（可增删），每项可为积分或优惠券列表
      extraRewards: [{
        rewardCategory: 2,
        ladderCount: '',
        rewardType: '',
        // 1: 积分, 2: 优惠券
        rewardValue: '',
        couponList: [{
          couponId: '',
          quantity: 1
        }]
      }],
      rules: {
        taskName: [{
          required: true,
          message: '请输入任务名称',
          trigger: 'blur'
        }],
        taskLabel: [{
          required: true,
          message: '请输入任务标签',
          trigger: 'blur'
        }],
        // taskDetail: [{ required: true, message: '请输入任务详情', trigger: 'blur' }],
        taskRequirement: [{
          required: true,
          message: '请输入任务要求',
          trigger: 'blur'
        }],
        taskTitle: [{
          required: true,
          message: '活动简介',
          trigger: 'blur'
        }],
        taskType: [{
          required: true,
          message: '请选择任务类型',
          trigger: 'change'
        }],
        mainImage: [{
          required: true,
          message: '请上传主图',
          trigger: 'change'
        }],
        detailImage: [{
          required: true,
          message: '请上传详情图',
          trigger: 'change'
        }],
        taskImage: [{
          required: true,
          message: '请上传banner图片',
          trigger: 'change'
        }],
        keywordList: [{
          required: true,
          message: '请输入关键词',
          trigger: 'blur'
        }],
        keywordCondition: [{
          required: true,
          message: '请输入匹配个数',
          trigger: 'blur'
        }],
        minContentLength: [{
          required: true,
          message: '请输入最少内容字数',
          trigger: 'blur'
        }],
        taskRule: [{
          required: true,
          message: '请输入活动规则',
          trigger: 'blur'
        }],
        taskSort: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }]
      },
      couponOptions1: [],
      couponLoading: false,
      typeOptions: []
    };
  },
  mounted: function mounted() {
    this.getTaskType();
  },
  created: function created() {},
  methods: {
    // When base reward type changes, ensure couponList exists when selecting 优惠券
    onBaseRewardTypeChange: function onBaseRewardTypeChange(val) {
      if (val == 2) {
        if (!this.baseReward.couponList || !Array.isArray(this.baseReward.couponList) || this.baseReward.couponList.length === 0) {
          this.baseReward.couponList = [{
            couponId: '',
            quantity: 1
          }];
        }
      } else {
        this.baseReward.couponList = null;
      }
    },
    // When extra reward type changes, ensure couponList exists for that extra when selecting 优惠券
    onExtraRewardTypeChange: function onExtraRewardTypeChange(extra, val) {
      if (val == 2) {
        if (!extra.couponList || !Array.isArray(extra.couponList) || extra.couponList.length === 0) {
          this.$set(extra, 'couponList', [{
            couponId: '',
            quantity: 1
          }]);
        }
      } else {
        this.$set(extra, 'couponList', null);
      }
    },
    getTaskType: function getTaskType() {
      var _this = this;
      var data = {
        page: 1,
        limit: 999
      };
      _redbook.default.getTaskType(data).then(function (res) {
        console.log('res', res);
        if (res.code == 200) {
          _this.typeOptions = res.records;
        }
      });
    },
    handleReduce: function handleReduce(index) {
      if (this.baseReward.couponList.length > 1) {
        this.baseReward.couponList.splice(index, 1);
      } else {
        this.$message.warning('至少保留一项优惠券');
      }
    },
    handleAdd: function handleAdd(index) {
      this.baseReward.couponList.push({
        couponId: '',
        quantity: 1
      });
    },
    // 优质额外奖励：新增一条奖励项（每项可以是积分或优惠券组合）
    addExtraReward: function addExtraReward() {
      this.extraRewards.push({
        rewardCategory: 2,
        ladderCount: '',
        rewardType: '',
        // 1: 积分, 2: 优惠券
        rewardValue: '',
        couponList: [{
          couponId: '',
          quantity: 1
        }]
      });
    },
    // 删除某一条奖励项
    removeExtraReward: function removeExtraReward(index) {
      if (this.extraRewards.length > 1) {
        this.extraRewards.splice(index, 1);
      } else {
        this.$message.warning('至少保留一条额外奖励');
      }
    },
    // 在某个额外奖励项下添加优惠券组合
    addCouponToExtra: function addCouponToExtra(extra) {
      if (!extra.couponList) extra.couponList = [];
      extra.couponList.push({
        couponId: '',
        quantity: 1
      });
    },
    // 删除额外奖励项中的某个优惠券组合
    removeCouponFromExtra: function removeCouponFromExtra(extra, idx) {
      if (extra.couponList && extra.couponList.length > 1) {
        extra.couponList.splice(idx, 1);
      } else {
        this.$message.warning('至少保留一项优惠券组合');
      }
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    // 获取任务详细信息
    fetchActDetail: function fetchActDetail(id) {
      var _this2 = this;
      var id2 = id;
      if (id.endsWith('_copy')) {
        id2 = id.replace('_copy', '');
      }
      _redbook.default.getTaskDetail(id2).then(function (res) {
        if (res.code !== 200) return;

        // baseReward 应为单个对象（基础奖励），extraRewards 为数组（额外奖励）
        var base = (res.data.rewardList || []).find(function (r) {
          return r.rewardCategory == 1;
        }) || null;
        _this2.baseReward = base ? Object.assign({}, _this2.baseReward, base) : _this2.baseReward;
        // 规范化 baseReward.couponList：如果是优惠券类型且无数组则初始化；否则置为 null
        if (_this2.baseReward.rewardType == 2) {
          if (!Array.isArray(_this2.baseReward.couponList) || _this2.baseReward.couponList.length === 0) {
            _this2.baseReward.couponList = [{
              couponId: '',
              quantity: 1
            }];
          }
        } else {
          _this2.baseReward.couponList = null;
        }
        _this2.extraRewards = (res.data.rewardList || []).filter(function (r) {
          return r.rewardCategory == 2;
        }) || [];
        // 规范化每一项 extraRewards 的 couponList
        _this2.extraRewards.forEach(function (er) {
          if (er.rewardType == 2) {
            if (!Array.isArray(er.couponList) || er.couponList.length === 0) {
              er.couponList = [{
                couponId: '',
                quantity: 1
              }];
            }
          } else {
            er.couponList = null;
          }
        });
        console.log("this.baseReward", _this2.baseReward);
        _this2.form = res.data; // 假设返回的数据结构是 { data: {...} }

        res.data.rewardList.forEach(function (item1) {
          if (item1.rewardType == 2) {
            var promises = item1.couponList.map(function (item) {
              return (0, _couponExpand.getCouponByThirdId)(item.couponId).then(function (response) {
                response.data.thirdCouponId = Number(response.data.thirdCouponId);
                // 不要赋值 push 的返回值，直接 push 到数组或返回数据由 Promise.all 统一赋值
                _this2.$set(item, 'couponName', response.data.typeName || '');
                return response.data;
              }).catch(function (error) {
                console.error('获取失败:', error);
                return null;
              });
            });
            Promise.all(promises).then(function (results) {
              // 过滤掉失败的 null，然后整体替换 couponOptions1
              _this2.couponOptions1 = results.filter(function (r) {
                return r;
              });
              console.log('couponOptions12', _this2.couponOptions1);
            });
          }
        });
        if (id.endsWith('_copy')) {
          _this2.form.id = null; // 复制新增时，清空ID
        }
        _this2.form.memberLevel = _this2.form.memberLevel ? _this2.form.memberLevel.split(',').map(Number) : [];
        if (_this2.form.validType == 2) {
          _this2.time = [];
        } else {
          var date = new Date(res.data.startTime);
          var date2 = new Date(res.data.endTime);
          var year = date.getFullYear();
          var month = _this2.pad(date.getMonth() + 1);
          var day = _this2.pad(date.getDate());
          var hours = _this2.pad(date.getHours());
          var mins = _this2.pad(date.getMinutes());
          var secs = _this2.pad(date.getSeconds());
          var startTime = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
          var year2 = date2.getFullYear();
          var month2 = _this2.pad(date2.getMonth() + 1);
          var day2 = _this2.pad(date2.getDate());
          var hours2 = _this2.pad(date2.getHours());
          var mins2 = _this2.pad(date2.getMinutes());
          var secs2 = _this2.pad(date2.getSeconds());
          var endTime = "".concat(year2, "-").concat(month2, "-").concat(day2, " ").concat(hours2, ":").concat(mins2, ":").concat(secs2);
          _this2.time = [startTime, endTime];
        }
        _this2.form.startTime = null;
        _this2.form.endTime = null;

        // 主图
        _this2.fileList = res.data.mainImage ? [{
          name: '主图',
          url: res.data.mainImage
        }] : [];
        // 详情图（可能多张，后端可能以逗号分隔）
        var detailImgs = res.data.detailImage ? String(res.data.detailImage).split(',').filter(Boolean) : res.data.orderShareImg ? [res.data.orderShareImg] : [];
        _this2.fileList2 = detailImgs.map(function (u) {
          return {
            name: '详情图',
            url: u
          };
        });
        // 分享卡片
        _this2.fileList3 = res.data.shareImage ? [{
          name: '分享卡片',
          url: res.data.shareImage
        }] : [];
        _this2.fileList4 = res.data.taskImage ? String(res.data.taskImage).split(',').filter(Boolean).map(function (u) {
          return {
            name: 'banner图',
            url: u
          };
        }) : [];
        console.log(" res", res);
      });
    },
    fetchCoupons1: function fetchCoupons1(query) {
      var _this3 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this3.couponOptions1 = res.records || [];
      }).finally(function () {
        _this3.couponLoading = false;
      });
    },
    // 统一上传处理，type: 'main' | 'detail' | 'share'
    handleCustomUpload: function handleCustomUpload(option, type) {
      var _this4 = this;
      var file = option && option.file ? option.file : option;
      var formData = new FormData();
      formData.append('file', file);
      (0, _taskConfig.uploadImg)(formData).then(function (res) {
        var url = res.data; // 按实际调整

        if (type === 'main') {
          _this4.form.mainImage = url;
          _this4.fileList = [{
            name: '主图',
            url: url
          }];
        } else if (type === 'share') {
          _this4.form.shareImage = url;
          _this4.fileList3 = [{
            name: '分享卡片',
            url: url
          }];
        } else if (type === 'detail') {
          var newItem = {
            name: file.name || '详情图',
            url: url
          };
          _this4.fileList2 = _this4.fileList2.concat([newItem]);
          _this4.form.detailImage = _this4.fileList2.map(function (f) {
            return f.url;
          }).join(',');
        } else if (type === 'banner') {
          var _newItem = {
            name: file.name || 'banner图',
            url: url
          };
          _this4.fileList4 = _this4.fileList4.concat([_newItem]);
          _this4.form.taskImage = _this4.fileList4.map(function (f) {
            return f.url;
          }).join(',');
        }
        _this4.$message.success('上传成功');
      }).catch(function () {
        _this4.$message.error('上传失败');
      });
    },
    // 统一移除处理
    handleUploadRemove: function handleUploadRemove(type, file, fileList) {
      if (type === 'main') {
        this.fileList = [];
        this.form.mainImage = '';
      } else if (type === 'share') {
        this.fileList3 = [];
        this.form.shareImage = '';
      } else if (type === 'detail') {
        this.fileList2 = fileList || [];
        this.form.detailImage = this.fileList2.map(function (f) {
          return f.url;
        }).join(',');
      } else if (type === 'banner') {
        this.fileList4 = fileList || [];
        this.form.taskImage = this.fileList4.map(function (f) {
          return f.url;
        }).join(',');
      }
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;
      // this.loading = true; // 开始加载
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var formData, clonedExtra, clonedBase, rewardList;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (valid) {
                  _context.next = 1;
                  break;
                }
                _this5.loading = false; // 停止加载
                return _context.abrupt("return");
              case 1:
                if (!(!_this5.time[0] && _this5.form.validType == 1)) {
                  _context.next = 2;
                  break;
                }
                _this5.$message.error('请选择活动时间');
                return _context.abrupt("return");
              case 2:
                formData = _this5.form;
                formData.memberLevel = _this5.form.userScope != 1 ? _this5.form.memberLevel.join(',') : '';
                if (_this5.form.validType == 2) {
                  formData.startTimeStr = null;
                  formData.endTimeStr = null;
                } else {
                  formData.startTimeStr = _this5.time[0];
                  formData.endTimeStr = _this5.time[1];
                }

                // 克隆 extraRewards，避免向原数组就地 push 导致页面数据变化
                clonedExtra = (_this5.extraRewards || []).map(function (r) {
                  return _objectSpread(_objectSpread({}, r), {}, {
                    couponList: r.couponList ? r.couponList.slice() : []
                  });
                });
                clonedBase = _this5.baseReward ? _objectSpread(_objectSpread({}, _this5.baseReward), {}, {
                  couponList: _this5.baseReward.couponList ? _this5.baseReward.couponList.slice() : []
                }) : null;
                rewardList = clonedExtra.slice();
                if (clonedBase) rewardList.push(clonedBase);
                formData.rewardList = rewardList;
                formData.rewardList.forEach(function (item) {
                  if (!item) return;
                  if (item.rewardType != 2) {
                    item.couponList = null;
                    return item;
                  }
                  if (Array.isArray(item.couponList)) {
                    item.couponList = item.couponList.map(function (it, idx) {
                      return {
                        couponId: it.couponId,
                        quantity: it.quantity,
                        sort: idx + 1
                      };
                    });
                  }
                  return item;
                });
                if (!!_this5.form.id) {
                  formData.rewardList = [];
                }
                console.log('formData', formData);
                _redbook.default.addTask(formData).then(function (res) {
                  if (res.code === 200) {
                    _this5.loading = false; // 停止加载
                    _this5.$message.success('操作成功');
                    _this5.handleClose();
                  } else {
                    _this5.loading = false; // 停止加载
                    _this5.$message.error(res.message);
                  }
                });
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleClose: function handleClose() {
      this.$emit('saved'); // 通知父组件刷新列表
    }
  }
};